import React from 'react';
import { useSelector } from 'react-redux';
import { RootState as C_RootState } from '@Redux/common/store';
import styles from '../style.module.scss';
import cN from 'classnames';
import { I_Meal } from '@Redux/detail/Itineraries/interfaces';

interface I_Props {
    mealList: Array<I_Meal>;
    mealTypes: number;
    DayID: number;
    toggleLightBox: (reqDayID: number, reqPOIID: string) => void;
}
const Meals: React.FC<I_Props> = ({ mealList, mealTypes, DayID, toggleLightBox }) => {
    const { curPage } = useSelector((store: C_RootState) => store.pageReducer);
    const mealIntToStringMap: { [key: number]: string } = {
        1: '早餐',
        2: '早午餐',
        4: '午餐',
        8: '下午茶',
        16: '晚餐',
        32: '宵夜',
    };

    const AllMeal: { [key: number]: Array<I_Meal> } = {};
    AllMeal[mealTypes] = mealList
        .filter((m: I_Meal) => m.MealTime === mealTypes)
        .map((n: I_Meal) => {
            return n;
        });

    return (
        <div>
            {AllMeal[mealTypes].length > 0 && (
                <div className={styles.mealWrapper}>
                    <span className={styles.mealTitle}>{mealIntToStringMap[mealTypes]}</span>
                    <div>
                        {AllMeal[mealTypes].map((item, idx: number) => (
                            <span
                                key={'meal' + idx}
                                className={cN(item.MealID && curPage !== 'print' && styles.trigger)}
                                onClick={() =>
                                    item.MealID &&
                                    curPage !== 'print' &&
                                    toggleLightBox(DayID, item.MealID)
                                }
                            >
                                {item.Name}
                                {idx === AllMeal[mealTypes].length - 1 ? '' : ' 或 '}
                            </span>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Meals;
